import { SupportInfo } from './SupportInfo.tsx';
import { SUPPORT_COLUMN } from './teamColumns.ts';
import { m } from '@/paraglide/messages.js';

/**
 * The titles above the colleague cards, on the same columns: who, and the
 * automatic-preparation switch with what it does — said once here instead of
 * on every card. Hidden from screen readers, since each switch names itself.
 */
export function TeamListHeader() {
  return (
    <div className='mt-5 flex items-center gap-5 px-5 text-xs font-medium text-ink-muted max-mobile:gap-3 max-mobile:px-4'>
      <span aria-hidden='true' className='flex-1 max-mobile:invisible'>
        {m.team_column_colleague()}
      </span>
      <span className={`flex items-center gap-0.5 ${SUPPORT_COLUMN}`}>
        <span aria-hidden='true'>{m.team_support_title()}</span>
        <SupportInfo />
      </span>
      <span aria-hidden='true' className='size-4 shrink-0 max-mobile:hidden' />
    </div>
  );
}
